import DefaultLayout from "../components/layout/DefaultLayout";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { userActions } from "../store/userSlice";
import { requestRecoveryPassword } from "../actions/users";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../routes";
import { useEffect } from "react";
import { isValidEmail } from "../helpers/stringUtils";

function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const email = useSelector((state) => state.user.recovery.email);
  const isLoading = useSelector((state) => state.user.recovery.loading);
  const redirectTo = useSelector((state) => state.user.redirectTo);
  const onChangeEmail = (event) => {
    dispatch(userActions.setRecoveryEmail(event.target.value));
  };
  const recoverHandler = () => {
    dispatch(requestRecoveryPassword(email));
  };

  useEffect(() => {
    if (redirectTo) {
      navigate(AppRoutes.LOGIN);
    }
  }, [redirectTo]);

  const body = () => {
    return (
      <div>
        <section className="slice sct-color-1">
          <div className="container relative">
            <div className="row">
              <div className="col-12">
                <div className="py-5 text-center">
                  <h1 className="heading heading-1 strong-400 text-normal">
                    Olvidaste tu contraseña?
                  </h1>
                  <span className="clearfix"></span>
                  <div className="fluid-paragraph fluid-paragraph-sm strong-300 text-center mt-1">
                    No te preocupes solo indicanos tu correo.
                  </div>
                  <Form>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInputEmail"
                    >
                      <Form.Control
                        type="email"
                        placeholder="ana.perez@ejemplo.com"
                        onChange={onChangeEmail}
                        defaultValue={email}
                      />
                    </Form.Group>
                  </Form>
                  <Button
                    disabled={isLoading || !isValidEmail(email)}
                    onClick={recoverHandler}
                  >
                    Recuperar contraseña
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default ForgotPassword;
